// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__HwQBs","message":"style_message__m6prQ","loader":"style_loader__ndGum","rotation":"style_rotation__9fXpq"};